import request from '@/utils/request'
/* 登录 */
export function loginByUsername(data) {
  return request({
    url: '/admin/auth/login',
    method: 'post',
    data,
  })
}
/*退出登录*/
export function logout(data) {
  return request({
    url: '/admin/auth/logout',
    method: 'post',
    headers:{
      "Token":data,
    }
  })
}
/*获取个人信息*/
export function getSelfInfo(data) {
  return request({
    url: '/admin/auth/self-info',
    method: 'get',
    params:data
  })
}

/*获取用户信息*/
export function getUserInfo() {
  return request({
    url: '/admin/auth/user/{userId}',
    method: 'get',
  })
}
